import app from '@/main';
import store from '@/store';
import axios from '@/api';

axios.interceptors.response.use(
  response => response,
  async error => {
    store.commit('setIsAppLoading', false);
    const errorModel = error.response
      ? {
          statusCode: error.response.status,
          data: {
            errors:
              error.response.data && error.response.data.errors
                ? error.response.data.errors
                : null,
            title:
              error.response.data && error.response.data.title
                ? error.response.data.title
                : null,
            traceId:
              error.response.data && error.response.data.traceId
                ? error.response.data.traceId
                : null,
          },
          config: {
            baseUrl: error.response.config.baseURL,
            url: error.response.config.url,
            method: error.response.config.method,
            headers: error.response.config.headers,
            data: error.response.config.data || null,
          },
        }
      : {};

    await app.$db
      .collection('logs')
      .doc()
      .set({
        datetime: new Date(),
        environment: app.$mode,
        message: errorModel,
        type: 'error',
      })
      .catch(e => e);

    app.$notify({
      title: 'Uygulama İletişim Hatası',
      text: 'Bir Hata Oluştu',
      type: 'danger',
    });

    return Promise.reject(
      error && error.response && error.response.data
        ? error.response.data
        : null
    );
  }
);
